<div class="col-12">
  <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()" [hidden]="resetSuccess">
    <div class="title">
      <span class="text">{{ 'auth.forgot-password.title' | translate }}</span>
    </div>

    <div class="subtitle">
      <span class="text">{{ 'auth.forgot-password.description' | translate }}</span>
    </div>

    <div class="alert alert-success" [hidden]="!resetSuccess">
      {{ 'auth.forgot-password.confirmed.description' | translate }}
    </div>

    <div class="alert alert-danger" [hidden]="!resetError">
      {{ 'auth.forgot-password.error' | translate }}
    </div>

    <cap-input formControlName="email"
               [label]="'auth.forgot-password.email' | translate"
               [placeholder]="'auth.forgot-password.email' | translate"
               data-test="email">
    </cap-input>

    <div class="flex-buttons">
      <cap-button styleClass="secondary"
                  routerLink="/auth/login"
                  type="button"
                  [label]="'auth.forgot-password.button.back' | translate"
                  data-test="back-button">
      </cap-button>

      <cap-button styleClass="primary"
                  type="submit"
                  [label]="'auth.reset-password.submit' | translate"
                  data-test="reset-password-button"
                  [disabled]="loading">
      </cap-button>
    </div>
  </form>
</div>
